import styled from 'styled-components';
import { Card } from '@veneer/core';
import primitives from '@veneer/primitives';
import { mixins } from '@jarvis/react-portal-addons';
import divHTMLRender from '../../../../shared/divHTMLRender';

export const CardBody = styled(Card)`
  && {
    grid-column: span 4;
    border-radius: 4;
    border: 0px;
    min-height: 204px;
    grid-column: span 12;

    ${mixins.md(`
      grid-column: span 6;
      min-height: 244px;
    `)}

    ${mixins.xl(`
      grid-column: span 4;
    `)}

    @media (min-width: 1920px) {
      min-height: 220px;
    }
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: left;
  height: 100%;

  ${mixins.xs(`
    width: 100%;
  `)}
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px 10px 0 0;
  background: ${primitives.color.hpBlue0};
  padding: 0 28px;

  > svg {
    margin-right: 10px;
    width: 20px;
    min-width: 20px;
  }
`;

export const HeaderText = styled(divHTMLRender)`
  color: ${primitives.color.gray9};
  margin: 8px 0px;
  text-align: center;
`;

export const ContentContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 0px 28px 28px;
  position: relative;
`;

export const Image = styled.img`
  width: 40px;
  height: 40px;
  position: absolute;
  top: 19px;
  right: 31px;
`;

export const Title = styled.h1`
  margin-bottom: 12px;
`;

export const Description = styled.p`
  padding-right: calc(40px + 28px + 16px); //image width + card padding + real padding
  margin-bottom: 16px;
`;

export const Footer = styled.div`
  margin-top: auto;
`;
